import React, { Fragment} from "react";
import HTMLFlipBook from "react-pageflip";
import ProductosVariables from "../cart/ProductosVariables";
import CarritoEnProductos from "../cart/CarritoEnProductos";
import MostrarVideos from "../MostrarVideos"

import "./flipbook.css";
import { Icon } from 'semantic-ui-react';

const PageCover = React.forwardRef((props, ref) => {
  let contenido = props.contenido
  return (
    <div className={"page page-cover " + contenido} ref={ref} data-density="hard">
      <div className="page-content">
        
      </div>
    </div>
  );
});

const Page = React.forwardRef((props, ref) => {
  let number = props.number
  return <div ref={ref} className={"Page"+number+" page"}>
       <div className="page-content">{props.children}</div> 
  </div>;
});




export default class MyBook extends React.Component {
  
  constructor(props) {
    super(props);

    this.state = {
      page: 0,
      totalPage: 0,
      contro: true
    };
  }

  bloquearClick = () => {
    this.flipBook.getPageFlip();
  };
  nextButtonClick = () => {
    this.flipBook.getPageFlip().flipNext();
  };

  prevButtonClick = () => {
    this.flipBook.getPageFlip().flipPrev();
  };

  onPage = (e) => {
    this.setState({
      page: e.data,
    });
  };
  
  cambiar = () =>{
  
    this.state.contro = false


  }

  componentDidMount() {
    this.setState({
      totalPage: this.flipBook.getPageFlip().getPageCount(),
    });
  }

  render() {

    return (
      <Fragment>
        <div className="row">
        <div className="col-12">
          <HTMLFlipBook
            width={535}
            height={740}
            size="stretch"
            minWidth={370}
            maxWidth={535}
            minHeight={518}
            maxHeight={740}
            maxShadowOpacity={0.5}
            maxShadowOpacity={0.5}
            showCover={true}
            mobileScrollSupport={true}
            onFlip={this.onPage}
            clickEventForward={true}
            useMouseEvents={false}
            usePortrait={true}
            onChangeOrientation={this.onChangeOrientation}
            onChangeState={this.onChangeState}
            ref={(el) => (this.flipBook = el)}
          >
            
              <PageCover contenido={"inicio"}> </PageCover>
           


              <Page number={1}> </Page>


              <Page number={2}> </Page>

              <Page number={3}></Page>

              <Page number={4}>
                <CarritoEnProductos idProducto={'47497'} left={"20px"} top={"215px"} width={"55px"} height={"55px"} addProductCart={this.props.addProductCart} />
                <CarritoEnProductos idProducto={'47498'} left={"260px"} top={"265px"} width={"55px"} height={"55px"} addProductCart={this.props.addProductCart} />
                </Page>

              <Page number={5}>
                <CarritoEnProductos idProducto={'2375'} left={"225px"} top={"35px"} width={"55px"} height={"55px"} addProductCart={this.props.addProductCart} />
                <ProductosVariables idProducto={'8971'} left={"8px"} top={"138px"} width={"35px"} height={"35px"} addProductCart={this.props.addProductCart} />
                <ProductosVariables idProducto={'47587'} left={"45px"} top={"138px"} width={"35px"} height={"35px"} addProductCart={this.props.addProductCart} />
                <CarritoEnProductos idProducto={'491'} left={"240px"} top={"225px"} width={"55px"} height={"55px"} addProductCart={this.props.addProductCart} />
                <CarritoEnProductos idProducto={'564'} left={"53px"} top={"560px"} width={"55px"} height={"55px"} addProductCart={this.props.addProductCart} />
                <CarritoEnProductos idProducto={'44751'} left={"410px"} top={"540px"} width={"55px"} height={"55px"} addProductCart={this.props.addProductCart} />
             </Page>

              <Page number={6}> </Page>

              <Page number={7}> </Page>


              <Page number={8}> 
              <CarritoEnProductos idProducto={'711'} left={"405px"} top={"25px"} width={"55px"} height={"55px"} addProductCart={this.props.addProductCart} />
              <ProductosVariables idProducto={'44737'} left={"200px"} top={"275px"} width={"55px"} height={"55px"} addProductCart={this.props.addProductCart} />
              <CarritoEnProductos idProducto={'10242'} left={"330px"} top={"540px"} width={"55px"} height={"55px"} addProductCart={this.props.addProductCart} />
              </Page>


              <Page number={9}>  </Page>


              <Page number={10}>
                <CarritoEnProductos idProducto={'47436'} left={"405px"} top={"415px"} width={"55px"} height={"55px"} addProductCart={this.props.addProductCart} />
              </Page>

              <Page number={11}></Page>

              <Page number={12}>
                <CarritoEnProductos idProducto={'47437'} left={"37px"} top={"135px"} width={"55px"} height={"55px"} addProductCart={this.props.addProductCart} />
                </Page>

              <Page number={13}>  </Page>

              <Page number={14}>
                <CarritoEnProductos idProducto={'47438'} left={"350px"} top={"200px"} width={"55px"} height={"55px"} addProductCart={this.props.addProductCart} />
              </Page>

              <Page number={15}> </Page>

              <Page number={16}>
                <CarritoEnProductos idProducto={'47439'} left={"350px"} top={"200px"} width={"55px"} height={"55px"} addProductCart={this.props.addProductCart} />
               </Page>

              <Page number={17}> </Page>

              <Page number={18}>
                <CarritoEnProductos idProducto={'47440'} left={"335px"} top={"220px"} width={"55px"} height={"55px"} addProductCart={this.props.addProductCart} />
              </Page>

              <Page number={19}>
              <CarritoEnProductos idProducto={'47442'} left={"298px"} top={"378px"} width={"55px"} height={"55px"} addProductCart={this.props.addProductCart} />
              </Page>

              <Page number={20}>
                <CarritoEnProductos idProducto={'47441'} left={"300px"} top={"35px"} width={"55px"} height={"55px"} addProductCart={this.props.addProductCart} />
                <CarritoEnProductos idProducto={'47443'} left={"68px"} top={"375px"} width={"55px"} height={"55px"} addProductCart={this.props.addProductCart} />
              </Page>

              <Page number={21}>
                  <CarritoEnProductos idProducto={'47444'} left={"375px"} top={"262px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
                  </Page>

              <Page number={22}></Page>

              <Page number={23}> </Page>

              <Page number={24}>
                <CarritoEnProductos idProducto={'2497'} left={"50px"} top={"200px"} width={"55px"} height={"55px"} addProductCart={this.props.addProductCart} />
                <CarritoEnProductos idProducto={'2415'} left={"400px"} top={"200px"} width={"55px"} height={"55px"} addProductCart={this.props.addProductCart} />
                <CarritoEnProductos idProducto={'5512'} left={"65px"} top={"560px"} width={"55px"} height={"55px"} addProductCart={this.props.addProductCart} />
                <CarritoEnProductos idProducto={'2402'} left={"405px"} top={"560px"} width={"55px"} height={"55px"} addProductCart={this.props.addProductCart} />
              </Page>

              <Page number={25}> </Page>

              <Page number={26}>
                <CarritoEnProductos idProducto={'33799'} left={"288px"} top={"300px"} width={"55px"} height={"55px"} addProductCart={this.props.addProductCart} />
                <CarritoEnProductos idProducto={'7935'} left={"55px"} top={"300px"} width={"55px"} height={"55px"} addProductCart={this.props.addProductCart} />
                <CarritoEnProductos idProducto={'2405'} left={"35px"} top={"445px"} width={"55px"} height={"55px"} addProductCart={this.props.addProductCart} />
                <CarritoEnProductos idProducto={'2407'} left={"420px"} top={"485px"} width={"55px"} height={"55px"} addProductCart={this.props.addProductCart} />
              </Page>

              <Page number={27}> </Page>

              <Page number={28}> </Page>

              <Page number={29}> </Page>


              <Page number={30}>
              <ProductosVariables idProducto={'8971'} left={"60px"} top={"250px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
              <ProductosVariables idProducto={'47587'} left={"400px"} top={"575px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
              </Page>

              <Page number={31}> 
              <CarritoEnProductos idProducto={'2464'} left={"450px"} top={"445px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
              <CarritoEnProductos idProducto={'6095'} left={"380px"} top={"552px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
              </Page>

              <Page number={32}>
              <ProductosVariables idProducto={'38317'} left={"138px"} top={"15px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
              <ProductosVariables idProducto={'8966'} left={"360px"} top={"15px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
              <ProductosVariables idProducto={'38230'} left={"50px"} top={"380px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
              <ProductosVariables idProducto={'2412'} left={"422px"} top={"328px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
              <ProductosVariables idProducto={'2327'} left={"268px"} top={"565px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
              </Page>

              <Page number={33}>
               <CarritoEnProductos idProducto={'2630'} left={"60px"} top={"138px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
                <CarritoEnProductos idProducto={'5361'} left={"130px"} top={"595px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
                <CarritoEnProductos idProducto={'5054'} left={"300px"} top={"575px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
               </Page>

              <Page number={34}>
              <CarritoEnProductos idProducto={'5869'} left={"5px"} top={"5px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
              <CarritoEnProductos idProducto={'3941'} left={"5px"} top={"140px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
              <CarritoEnProductos idProducto={'23444'} left={"370px"} top={"215px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
              <CarritoEnProductos idProducto={'2635'} left={"45px"} top={"595px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
              <CarritoEnProductos idProducto={'2634'} left={"175px"} top={"595px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
              <CarritoEnProductos idProducto={'18620'} left={"290px"} top={"595px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
              <CarritoEnProductos idProducto={'2633'} left={"400px"} top={"595px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
               </Page>

              <Page number={35}></Page>

              <Page number={36}>
                <ProductosVariables idProducto={'43175'} left={"170px"} top={"30px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
                <ProductosVariables idProducto={'8969'} left={"170px"} top={"595px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
               <ProductosVariables idProducto={'2552'} left={"315px"} top={"595px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
              </Page>

              <Page number={37}> </Page>

              <Page number={38}>
              <ProductosVariables idProducto={'8965'} left={"385px"} top={"215px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
              <CarritoEnProductos idProducto={'712'} left={"395px"} top={"505px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
              </Page>

              <Page number={39}>
               <CarritoEnProductos idProducto={'2522'} left={"115px"} top={"175px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
               </Page>

              <Page number={40}>
              <CarritoEnProductos idProducto={'4199'} left={"435px"} top={"60px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
              <CarritoEnProductos idProducto={'38869'} left={"385px"} top={"135px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
              <CarritoEnProductos idProducto={'2559'} left={"350px"} top={"240px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
              <CarritoEnProductos idProducto={'2562'} left={"218px"} top={"305px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
              <CarritoEnProductos idProducto={'47562'} left={"310px"} top={"345px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
              <CarritoEnProductos idProducto={'2561'} left={"185px"} top={"420px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
              <CarritoEnProductos idProducto={'2560'} left={"70px"} top={"505px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
              <CarritoEnProductos idProducto={'2376'} left={"340px"} top={"590px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
              </Page>

              <Page number={41}>  </Page>

              <Page number={42}>
                <CarritoEnProductos idProducto={'1904'} left={"35px"} top={"460px"} width={"55px"} height={"55px"} addProductCart={this.props.addProductCart} />
                <CarritoEnProductos idProducto={'2328'} left={"35px"} top={"535px"} width={"55px"} height={"55px"} addProductCart={this.props.addProductCart} />
                <CarritoEnProductos idProducto={'1900'} left={"35px"} top={"605px"} width={"55px"} height={"55px"} addProductCart={this.props.addProductCart} />
                <CarritoEnProductos idProducto={'1896'} left={"255px"} top={"465px"} width={"55px"} height={"55px"} addProductCart={this.props.addProductCart} />
                <CarritoEnProductos idProducto={'1908'} left={"255px"} top={"525px"} width={"55px"} height={"55px"} addProductCart={this.props.addProductCart} />
               </Page>

              <Page number={43}>
                <CarritoEnProductos idProducto={'1099'} left={"400px"} top={"210px"} width={"55px"} height={"55px"} addProductCart={this.props.addProductCart} />
                <ProductosVariables idProducto={'1066'} left={"55px"} top={"465px"} width={"55px"} height={"55px"} addProductCart={this.props.addProductCart} />
                <CarritoEnProductos idProducto={'1096'} left={"325px"} top={"590px"} width={"55px"} height={"55px"} addProductCart={this.props.addProductCart} />
                </Page>

              <Page number={44}>
                <ProductosVariables idProducto={'7548'} left={"50px"} top={"450px"} width={"55px"} height={"55px"} addProductCart={this.props.addProductCart} />
                <ProductosVariables idProducto={'8036'} left={"405px"} top={"265px"} width={"55px"} height={"55px"} addProductCart={this.props.addProductCart} />
              </Page>

              <Page number={45}>  </Page>


              <Page number={46}>  </Page>


              <Page number={47}>
              <ProductosVariables idProducto={'6959'} left={"325px"} top={"7px"} width={"55px"} height={"55px"} addProductCart={this.props.addProductCart} />
              <ProductosVariables idProducto={'5691'} left={"395px"} top={"585px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
              </Page>

              <Page number={48}>
                <CarritoEnProductos idProducto={'1919'} left={"35px"} top={"600px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
                <ProductosVariables idProducto={'8968'} left={"348px"} top={"13px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
              </Page>

              <Page number={49}> </Page>

              <Page number={50}>
                <ProductosVariables idProducto={'32441'} left={"170px"} top={"40px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
              </Page>

              <Page number={51}> </Page>

              <Page number={52}>  </Page>

              <Page number={53}> </Page>


              <Page number={54}>
               <ProductosVariables idProducto={'47699'} left={"380px"} top={"344px"} width={"40px"} height={"40px"} addProductCart={this.props.addProductCart} />
               <ProductosVariables idProducto={'44737'} left={"50px"} top={"560px"} width={"40px"} height={"40px"} addProductCart={this.props.addProductCart} />
               <ProductosVariables idProducto={'44751'} left={"175px"} top={"560px"} width={"40px"} height={"40px"} addProductCart={this.props.addProductCart} />
               <ProductosVariables idProducto={'44761'} left={"300px"} top={"560px"} width={"40px"} height={"40px"} addProductCart={this.props.addProductCart} />
               <CarritoEnProductos idProducto={'564'} left={"430px"} top={"560px"} width={"40px"} height={"40px"} addProductCart={this.props.addProductCart} />
               </Page>

              <Page number={55}> </Page>

              <Page number={56}>
                <CarritoEnProductos idProducto={'9205'} left={"405px"} top={"65px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
                <CarritoEnProductos idProducto={'9206'} left={"465px"} top={"245px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
                <CarritoEnProductos idProducto={'709'} left={"220px"} top={"385px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
                <CarritoEnProductos idProducto={'8517'} left={"25px"} top={"630px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
                <CarritoEnProductos idProducto={'716'} left={"260px"} top={"630px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
              </Page>

              <Page number={57}> </Page>

              <Page number={58}>
                <CarritoEnProductos idProducto={'710'} left={"190px"} top={"8px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
                <CarritoEnProductos idProducto={'708'} left={"415px"} top={"55px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
                <CarritoEnProductos idProducto={'713'} left={"10px"} top={"265px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
                <CarritoEnProductos idProducto={'706'} left={"445px"} top={"270px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
                <CarritoEnProductos idProducto={'2346'} left={"55px"} top={"625px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
                <CarritoEnProductos idProducto={'699'} left={"305px"} top={"620px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
               </Page>

              <Page number={59}> </Page>

              <Page number={60}>
                <CarritoEnProductos idProducto={'501'} left={"80px"} top={"570px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
                <CarritoEnProductos idProducto={'6977'} left={"165px"} top={"570px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
                <CarritoEnProductos idProducto={'5634'} left={"245px"} top={"570px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
                <CarritoEnProductos idProducto={'500'} left={"340px"} top={"570px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
                <CarritoEnProductos idProducto={'504'} left={"430px"} top={"570px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
               </Page>

              <Page number={61}>
                <CarritoEnProductos idProducto={'502'} left={"335px"} top={"240px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
                <CarritoEnProductos idProducto={'503'} left={"330px"} top={"595px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
               </Page>

              <Page number={62}>
                <CarritoEnProductos idProducto={'7194'} left={"-3px"} top={"380px"} width={"55px"} height={"55px"} addProductCart={this.props.addProductCart} />
                <CarritoEnProductos idProducto={'7199'} left={"172px"} top={"275px"} width={"55px"} height={"55px"} addProductCart={this.props.addProductCart} />
                <CarritoEnProductos idProducto={'7190'} left={"172px"} top={"350px"} width={"55px"} height={"55px"} addProductCart={this.props.addProductCart} />
              </Page>

              <Page number={63}>
              <CarritoEnProductos idProducto={'47580'} left={"405px"} top={"160px"} width={"55px"} height={"55px"} addProductCart={this.props.addProductCart} />
               </Page>

              <Page number={64}>
                <CarritoEnProductos idProducto={'2377'} left={"380px"} top={"430px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
                <CarritoEnProductos idProducto={'485'} left={"25px"} top={"605px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
                <CarritoEnProductos idProducto={'487'} left={"210px"} top={"605px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
               </Page>

              <Page number={65}> </Page>

              <Page number={66}>
                <CarritoEnProductos idProducto={'7879'} left={"52px"} top={"570px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
                <CarritoEnProductos idProducto={'497'} left={"155px"} top={"570px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
                <CarritoEnProductos idProducto={'494'} left={"235px"} top={"570px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
                <CarritoEnProductos idProducto={'495'} left={"320px"} top={"570px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
                <CarritoEnProductos idProducto={'496'} left={"410px"} top={"570px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
               </Page>

              <Page number={67}> </Page>

              <Page number={68}>
                <CarritoEnProductos idProducto={'474'} left={"40px"} top={"560px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
                <CarritoEnProductos idProducto={'478'} left={"135px"} top={"560px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
                <CarritoEnProductos idProducto={'480'} left={"225px"} top={"560px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
                <CarritoEnProductos idProducto={'476'} left={"330px"} top={"560px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
                <CarritoEnProductos idProducto={'482'} left={"430px"} top={"560px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
                </Page>

              <Page number={69}>
              <CarritoEnProductos idProducto={'38412'} left={"360px"} top={"315px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
               </Page>

              <Page number={70}>
                <CarritoEnProductos idProducto={'44363'} left={"385px"} top={"395px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
              </Page>

              <Page number={71}>
                <CarritoEnProductos idProducto={'30139'} left={"100px"} top={"165px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
                <MostrarVideos link={'https://www.youtube.com/watch?v=APJh1wIfxhI'} left={"325px"} top={"590px"} width={"50px"} height={"50px"} />
             </Page>

              <Page number={72}> </Page>

              <Page number={73}>
                <CarritoEnProductos idProducto={'15352'} left={"65px"} top={"160px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
              </Page>

              <Page number={74}> </Page>

              <Page number={75}></Page>

              <Page number={76}>
              <CarritoEnProductos idProducto={'38413'} left={"85px"} top={"455px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
              </Page>

              <Page number={77}>
              <CarritoEnProductos idProducto={'5510'} left={"405px"} top={"210px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
              <CarritoEnProductos idProducto={'881'} left={"120px"} top={"640px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
              <CarritoEnProductos idProducto={'2483'} left={"330px"} top={"650px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
              </Page>

              <Page number={78}>
              <CarritoEnProductos idProducto={'895'} left={"60px"} top={"180px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
              <CarritoEnProductos idProducto={'901'} left={"175px"} top={"175px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
              <CarritoEnProductos idProducto={'898'} left={"275px"} top={"175px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
              <CarritoEnProductos idProducto={'887'} left={"410px"} top={"245px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
               </Page>



              <Page number={79}></Page>

              <Page number={80}></Page>

              <Page number={81}></Page>

              <Page number={82}></Page>

           
            </HTMLFlipBook>
            </div>
         
        </div>
        <div id="slide">
          <div className="flechas" id="retroceder"  onClick={this.prevButtonClick}> <Icon name='angle left'  size='huge' /></div>
          <div className="flechas" id="avanzar"   onClick={this.nextButtonClick}><Icon name='angle right'  size='huge' />  </div>
        </div>
        


        
      </Fragment>
    );
  }
}

